var render = function render(){var _vm=this,_c=_vm._self._c;return _c('BottomSheet',{attrs:{"show":_vm.show,"zIndex":9999},on:{"close":function($event){return _vm.$emit('close')}}},[_c('div',{staticClass:"flex justify-center -mt-12 mb-2"},[_c('div',{class:[
        _vm.type === 'success'
          ? 'bg-green-500'
          : _vm.type === 'error'
          ? 'bg-red-500'
          : 'bg-blue-500',
        'rounded-full w-20 h-20 flex items-center justify-center shadow-lg border-4 border-white'
      ]},[_c('i',{class:[
          _vm.type === 'success'
            ? 'bx bx-check-circle'
            : _vm.type === 'error'
            ? 'bx bx-x-circle'
            : 'bx bx-info-circle',
          'text-white text-4xl'
        ]})])]),_c('div',{staticClass:"px-6"},[_c('h2',{staticClass:"text-2xl font-bold text-center mb-1"},[_vm._v(_vm._s(_vm.title))]),_c('p',{staticClass:"text-gray-500 text-center mb-4"},[_vm._v(_vm._s(_vm.description))]),_c('div',{staticClass:"flex justify-center mt-4"},[_c('CuButton',{staticClass:"flex-1",attrs:{"primary":""},on:{"click":function($event){return _vm.$emit('close')}}},[_vm._v("Chiudi")])],1)])])
}
var staticRenderFns = []

export { render, staticRenderFns }